export default {
    home_page_title: "账号资料",
    security_page_title: "安全中心",
    security_setting_page_title: "安全中心",
    security_phone_label: "手机",
    security_email_label: "邮箱",
    security_question_label: "密保问题",
    security_unset_text: "未设置",
    security_setted_text: "已设置",
    security_question_options: [
        "您母亲的姓名是?",
        "您配偶的生日是?",
        "您父亲的姓名是?",
        "您的学号（或工号）是?",
        "您最熟悉的童年好友名字是?",
        "对您影响最大的人名字是?"
    ],
    password_lost_page_title: "忘记密码",
    password_reset_page_title: "重置密码",
    password_lost_account_placeholder: "输入忘记密码的账号",
    empty_lost_account_tips: "用户名不能为空",
    iscorrect_lost_account_tips: "用户不存在",
    password_reset_new_placeholder: "新密码",
    password_reset_confirm_placeholder: "确认新密码",
    password_verify_page_title: "验证身份",
    phone_verify_page_title: "验证身份",
    email_verify_page_title: "验证身份",
    question_verify_page_title: "验证身份",
    phone_reset_page_title: "手机",
    email_reset_page_title: "邮箱",
    question_reset_page_title: "密保问题",
    phone_binding_text: "您的绑定的手机号为",
    email_binding_text: "您的绑定的邮箱为",
    verification_code_text: "验证码",
    resend_text: "重新发送",
    empty_phone_number_tips: "请输入手机号",
    iscorrect_phone_number_tips: "请输入正确格式的手机号码",
    empty_verification_code_tips: "请输入验证码",
    iscorrect_verification_code_tips: "验证码错误",
    password_placeholder: "密码",
    empty_password_tips: "请输入密码",
    iscorrect_password_tips: "密码错误",
    mismatched_rule_password_tips: "密码不能包含&、#、空格",
    different_confirm_password_tips: "密码不一致",
    empty_email_tips: "请输入邮箱",
    iscorrect_email_tips: "邮箱错误",
    answer_placeholder: "答案",
    empty_question_tips: "选择密保问题",
    empty_answer_tips: "输入答案",
    iscorrect_answer_tips: "答案错误",
    next_step_text: "下一步",
    submit_text: "提交",
    submit_success_tips: "设置成功",
    submit_error_tips: "操作失败，请重试",
    get_data_fail_tips: "网络异常,请稍后重试",
    use_other_verification_type_text: "其他方式验证",
    custom_support_notice:
        "该账号未设置密保方式，您可以通过在PC端打开下方链接进行申诉." +
        process.env.VUE_APP_ORIGIN_PROFILE
};
